const MAX_LINES = 20;
const MAX_LINE_CHARS = 800;

const buffer = [];

const REDACT_PATTERNS = [
  [/Bearer\s+[A-Za-z0-9\-._~+/]+=*/gi, "Bearer [redacted]"],
  [/(authorization["']?\s*[:=]\s*["']?)[^"'\s,}]+/gi, "$1[redacted]"],
  [/(password["']?\s*[:=]\s*["']?)[^"']*/gi, "$1[redacted]"],
  [/(token["']?\s*[:=]\s*["']?)[^"'\s,}]+/gi, "$1[redacted]"],
  [/(secret["']?\s*[:=]\s*["']?)[^"'\s,}]+/gi, "$1[redacted]"],
  [/eyJ[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+/g, "[jwt redacted]"],
];

function redactText(text) {
  let out = String(text ?? "");
  for (const [pattern, replacement] of REDACT_PATTERNS) {
    out = out.replace(pattern, replacement);
  }
  if (out.length > MAX_LINE_CHARS) {
    out = `${out.slice(0, MAX_LINE_CHARS - 3)}...`;
  }
  return out;
}

function formatConsoleArg(arg) {
  if (arg == null) return String(arg);
  if (arg instanceof Error) {
    return redactText(`${arg.name}: ${arg.message}${arg.stack ? `\n${arg.stack}` : ""}`);
  }
  if (typeof arg === "object") {
    try {
      return redactText(JSON.stringify(arg));
    } catch {
      return redactText(String(arg));
    }
  }
  return redactText(String(arg));
}

function pushLine(level, args) {
  const text = redactText([...args].map(formatConsoleArg).join(" "));
  if (!text.trim()) return;
  buffer.push({
    time: new Date().toISOString(),
    level,
    text,
  });
  while (buffer.length > MAX_LINES) {
    buffer.shift();
  }
}

/** Capture recent console.error / console.warn for optional bug-report appendix. */
export function installClientDiagnosticsBuffer() {
  if (typeof window === "undefined" || window.__neweraDiagnosticsBufferInstalled) return;
  window.__neweraDiagnosticsBufferInstalled = true;

  const origError = console.error;
  const origWarn = console.warn;

  console.error = (...args) => {
    pushLine("ERROR", args);
    origError.apply(console, args);
  };

  console.warn = (...args) => {
    pushLine("WARN", args);
    origWarn.apply(console, args);
  };
}

export function getRecentConsoleDiagnostics(maxLen = 3000) {
  if (!buffer.length) return "";
  const joined = buffer.map((e) => `[${e.time}] ${e.level}: ${e.text}`).join("\n");
  if (joined.length <= maxLen) return joined;
  return `${joined.slice(0, maxLen - 20)}\n...(truncated)`;
}
